import React from "react";
import SkeletonCard from "./SkeletonCard";


const AnalyticsTable = ({ isLoading, data = [] }) => {
 const pageData =
   data.length > 0
     ? data.map((item) => ({
         title: item.pageTitle,
         views: Number(item.views),
         users: Number(item.active_users),
         events: Number(item.events),
         bounce: Number(item.bounce_rate),
       }))
     : [];

  const maxViews = Math.max(...pageData.map((item) => item.views), 1);
  const maxUsers = Math.max(...pageData.map((item) => item.users), 1);
  const maxEvents = Math.max(...pageData.map((item) => item.events), 1);
  const maxBounce = Math.max(...pageData.map((item) => item.bounce), 1);

  const renderCell = (value, percent) => (
    <>
      <small className="text-muted">{value}</small>
      <div
        className="progress w-100 mt-4"
        style={{ height: "4px", marginBottom: "-14px" }}
      >
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${percent}%`, backgroundColor: "#FF5837" }}
        ></div>
      </div>
    </>
  );

  const renderBounceCell = (value, percent) =>
    parseFloat(value) === 0 ? (
      <small className="text-muted">0%</small>
    ) : (
      renderCell(`${value}%`, percent)
    );

  return (
    <div className="container my-4">
      <div className="table-responsive w-100" style={{height:"650px"}}>
        {isLoading ? (
          <SkeletonCard count={14} height={20} />
        ) : (
          <>
            <div className="w-100 text-end mb-2 mt-1">
              <h5 className="mt-1 p-1">Top Pages/Screens</h5>
            </div>
            <table className="table align-middle w-100">
              <thead className="table-light" >
                <tr>
                  <th>Page Title and Screen Class</th>
                  <th>Views</th>
                  <th>Active Users</th>
                  <th>Event Count</th>
                  <th>Bounce Rate</th>
                </tr>
              </thead>
              <tbody>
                {pageData.map((page, i) => {
                  const viewPercent = Math.round((page.views / maxViews) * 100);
                  const userPercent = Math.round((page.users / maxUsers) * 100);
                  const eventPercent = Math.round(
                    (page.events / maxEvents) * 100
                  );
                  const bouncePercent = Math.round(
                    (page.bounce / maxBounce) * 100
                  );

                  return (
                    <tr key={i}>
                      <td>{page.title}</td>
                      <td>{renderCell(page.views, viewPercent)}</td>
                      <td>{renderCell(page.users, userPercent)}</td>
                      <td>{renderCell(page.events, eventPercent)}</td>
                      <td>{renderBounceCell(page.bounce, bouncePercent)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default AnalyticsTable;
